import { QueryResult, useQuery } from '@apollo/client'
import { Country, GetAppraisalSeasonOpeningInfoQuery, GetAppraisalSeasonOpeningInfoQueryVariables } from '../../types'
import { GET_APPRAISAL_SEASON_OPENING_INFO } from './Queries'

export const useAppraisalSeasonOpeningInfo = (
  companyId: string,
  country: Country,
): QueryResult<GetAppraisalSeasonOpeningInfoQuery, GetAppraisalSeasonOpeningInfoQueryVariables> => {
  return useQuery<GetAppraisalSeasonOpeningInfoQuery, GetAppraisalSeasonOpeningInfoQueryVariables>(GET_APPRAISAL_SEASON_OPENING_INFO, {
    variables: { companyId, country },
    fetchPolicy: 'network-only',
  })
}
